module.exports = __webpack_public_path__ + "assets/img/code.dd64a967.png";